module.exports = __webpack_public_path__ + "static/media/loader_dots.47e0e652.gif";